import React from 'react';
import PropTypes from 'prop-types';

// Styles
import styles from './currentStatus.scss';

export const CurrentStatus = ({ active, statusText, className = '' }) => (
  <span
    className={`${styles.status} ${active ? styles.active : ''} ${className}`}
  >
    {statusText}
  </span>
);

CurrentStatus.propTypes = {
  active: PropTypes.bool.isRequired,
  statusText: PropTypes.string.isRequired,
  className: PropTypes.string,
};

